// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"command"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.5 9.5V14.5M14.5 9.5H9.5M14.5 9.5V6.5C14.5 4.84315 15.8431 3.5 17.5 3.5C19.1569 3.5 20.5 4.84315 20.5 6.5C20.5 8.15685 19.1569 9.5 17.5 9.5H14.5ZM14.5 14.5H9.5M14.5 14.5H17.5C19.1569 14.5 20.5 15.8431 20.5 17.5C20.5 19.1569 19.1569 20.5 17.5 20.5C15.8431 20.5 14.5 19.1569 14.5 17.5V14.5ZM9.5 14.5V9.5M9.5 14.5V17.5C9.5 19.1569 8.15685 20.5 6.5 20.5C4.84315 20.5 3.5 19.1569 3.5 17.5C3.5 15.8431 4.84315 14.5 6.5 14.5H9.5ZM9.5 9.5H6.5C4.84315 9.5 3.5 8.15685 3.5 6.5C3.5 4.84315 4.84315 3.5 6.5 3.5C8.15685 3.5 9.5 4.84315 9.5 6.5V9.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const CommandIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'command',
    ref,
    icon: element,
  },
));

CommandIcon.displayName = 'CommandIcon';

export default CommandIcon;
